import React, {useState} from 'react';
import {withRouter} from 'react-router'
import image from '../loading.gif'
import 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import './login.css'
import firebase from '../firebase'

const LoginComponent = (props) => {

    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const loginMe = async()=>{
        setLoading(true);
            try{
                await firebase.login(email,password)
                setLoading(false);
                props.history.replace('/dashboard');
            }catch(error){
                setLoading(false);
                alert(error.message);
            }
    }
    const gotoSignUp = ()=>{
        props.history.replace('/signup')
    }
    return (
        <div id="signBack">
            {loading?<div className="loading"><img alt="Loading" src={image}/></div>:null}
            <div id="form">
                <h2>Gotta GO!<span role="img" onSubmit={e=>e.preventDefault() && false} aria-label="RunEmoji">🏃‍♂️</span></h2>
                <h3>Sign In</h3>
                <div className="input-field col s12">
                    <input id="email" type="email" className="validate" required autoFocus value={email} onChange={e=>setEmail(e.target.value)}/>
                    <label htmlFor="email">Enter Your Email</label>
                </div>
               
                <div className="input-field col s12">
                    <input id="password" type="password" className="validate" required value={password} onChange={e=>setPassword(e.target.value)}/>
                    <label htmlFor="password">Enter Your Password</label>
                </div>
                
                <button className="cusButton" type="submit" onClick={loginMe}>Login</button>
                <button className="cusButton" id="withGoogle" onClick={gotoSignUp}>Sign Up</button>
            </div>
        </div>
    )
}

export default withRouter(LoginComponent);